
import { computed, defineComponent, ref, watch } from 'vue'
import { useRouter } from 'vue-router'
import PaymentAdminApi from '@/core/services/payment/PaymentAdminApi'
import { orderStatusLabels } from '@/core/services/payment/labels'
import { OrderStatus } from '@/core/services/payment/types'
import { formatAgo, formatMoney } from '@/core/helpers/paymentFormat'
import { useWidgetData } from '@/core/dashboard/useWidgetData'
import { useDashboardContext } from '@/core/dashboard/dashboardContext'
import DashboardWidget from '@/core/components/dashboard/DashboardWidget.vue'
import StatTile from '@/core/components/dashboard/StatTile.vue'

/** Виджет платежей: что требует внимания, динамика за сутки, деньги и быстрые действия. */
export default defineComponent({
  name: 'PaymentsWidget',
  components: { DashboardWidget, StatTile },
  setup() {
    const router = useRouter()
    const context = useDashboardContext()
    const { data, loading, error, updatedAt, refresh } = useWidgetData(
      PaymentAdminApi.dashboard.get
    )

    watch(data, value => {
      if (value) {
        context.report('payments', value.attention)
      }
    })

    // Неоплаченные заказы любым способом: сумма и деление «по счёту / картой».
    const unpaidHint = computed(() => {
      const unpaid = data.value && data.value.orders_unpaid
      if (!unpaid || !unpaid.count) {
        return 'неоплаченных заказов нет'
      }
      return `на ${formatMoney(unpaid.amount)} · по счёту ${unpaid.by_invoice}, картой ${unpaid.by_card}`
    })

    // Дата «сутки назад» в формате фильтра заказов (локальная, YYYY-MM-DD).
    const yesterday = computed(() => {
      const d = new Date(Date.now() - 24 * 3600 * 1000)
      const pad = (n: number) => String(n).padStart(2, '0')
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
    })

    const orderNumber = ref('')
    const findOrder = () => {
      const number = orderNumber.value.trim()
      if (number) {
        router.push({ name: 'payments-orders', query: { number } })
      }
    }

    return {
      data,
      loading,
      error,
      updatedAt,
      refresh,
      unpaidHint,
      yesterday,
      orderNumber,
      findOrder,
      statuses: Object.keys(orderStatusLabels) as OrderStatus[],
      statusLabels: orderStatusLabels,
      money: formatMoney,
      ago: formatAgo,
    }
  },
})
